import appConfig from '@/apps/sipa/app.config.js'
export default [
  {
    path: "sipa",
    name: "sipa",
    redirect: "SipaUpload",
  },
    {
      path: 'SipaUpload',
      name: 'Sipa Upload',
      component: () => import(/* webpackChunkName: "sippa-SippaUpload" */ '../views/SipaUpload.vue'),
      meta: {
        mainNavEnabled: false,
        
      },
    },
    /*{
        path: "TemplateUpload",
        name: "Template Upload",
        component: () =>
          import(
            /* webpackChunkName: "sippa-templateupload" */ //"../views/TemplateUpload.vue"
        /*  ),
        meta: {
          mainNavEnabled: isParentNavEnabled,
        },
      },*/
]
